import React, { useEffect } from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import Testimonials from "../Home/Testimonials";
import GetInTouch from "../Home/GetInTouch";
import WhyChooseUs from "../Home/WhyChooseUs";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us - ";
  }, []);

  return (
    <React.Fragment>
      <div class="page_wrapper">
        <Header headerType="white_header" />

        {/* breadcrumb area start */}
        <section className="nh_breadcrumb-area">
          <div
            className="nh_breadcrumb-wrap"
            data-background="assets/images/bg/breadcrumb.webp"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7">
                  <div className="nh_breadcrumb-content text-center">
                    <h2 className="nh_breadcrumb-content-title">About Us</h2>
                    <div className="nh_breadcrumb-content-list">
                      <a href="/">Home</a>
                      <span>About Us</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <>
          {/* reason area end */}
          {/* about area start */}
          <section className="h2_nh_about-area pb-100 pt-100">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="appie-title">Who We Are</h3>
                  <p className="pt-2 text-justify">
                    FINGTEL COMMUNICATIONS is a versatile platform dedicated to
                    simplifying mobile and DTH recharges while empowering users
                    with a rewarding experience. Our passionate team focuses on
                    creating a reliable, user-friendly solution that benefits
                    individuals and businesses alike. By prioritizing speed,
                    security, and convenience, FINGTEL COMMUNICATIONS is the
                    preferred choice for all your recharge needs.
                  </p>
                  <h4 className="pt-3">Our Vision</h4>
                  <p className="pt-2 text-justify">
                    Our vision is to become a leader in the recharge industry,
                    known for innovation, user satisfaction, and value. We aim
                    to transform how people stay connected, offering a seamless
                    and rewarding recharge experience for everyone.
                  </p>
                  <h4 className="pt-3">Our Mission</h4>
                  <p className="pt-2 text-justify">
                    Our mission is to deliver fast, secure, and convenient
                    recharge services, providing users with ease and added
                    value. We are committed to continuously enhancing our
                    platform, ensuring that users enjoy a seamless experience
                    while maximizing the benefits of every recharge.
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="about-image pl-5">
                    <img
                      src="images/about-us.png"
                      className="about2"
                      alt="about"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* about area end */}
        </>
        <WhyChooseUs />
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default AboutUs;
